import React, { useEffect, useRef, useState, useLayoutEffect } from 'react';
import { IAccordionItem } from "../../../Models/IAccordionItem";

interface AccordionProps {
    data: IAccordionItem;
}

const Accordion: React.FC<AccordionProps> = ({ data }) => {
    const [isActive, setIsActive] = useState(false);
    const [height, setHeight] = useState(0);

    const bodyRef = useRef<HTMLDivElement>(null);

    function getFullHeightWithMargins(container: HTMLElement): number {
        const children = Array.from(container.children) as HTMLElement[];
        if (children.length === 0) return 0;

        const firstChild = children[0];
        const lastChild = children[children.length - 1];

        const firstRect = firstChild.getBoundingClientRect();
        const lastRect = lastChild.getBoundingClientRect();
        const parentRect = container.getBoundingClientRect();

        const marginTop = parseFloat(getComputedStyle(firstChild).marginTop);
        const marginBottom = parseFloat(getComputedStyle(lastChild).marginBottom);

        const top = firstRect.top - marginTop;
        const bottom = lastRect.bottom + marginBottom;

        return bottom - parentRect.top;
    }

    useLayoutEffect(() => {
        if (isActive && bodyRef.current) {
            const newHeight = getFullHeightWithMargins(bodyRef.current);
            setHeight(newHeight);
        } else {
            setHeight(0);
        }
    }, [isActive, data.Content]);

    useEffect(() => {
        const handleResize = () => {
            if (isActive && bodyRef.current) {
                const newHeight = getFullHeightWithMargins(bodyRef.current);
                setHeight(newHeight);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [isActive]);

    const handleOnClick = () => {
        setIsActive(prev => !prev);
    };

    return (
        <div className={`layout--accordion ${isActive ? 'is-active' : 'is-not-active'} u-relative_hidden`}>
            <div className="accordion__heading">
                {data.Title && (
                    <h4 onClick={handleOnClick}>
                        {data.Title}
                    </h4>
                )}
                <svg
                    onClick={handleOnClick}
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fillRule="evenodd"
                    clipRule="evenodd"
                >
                    <path d="M11 11V0h1v11h11v1H12v11h-1V12H0v-1h11z" />
                </svg>
            </div>

            <div
                className="accordion__content u-relative_hidden"
                style={{
                    height: isActive ? height : 0,
                    overflow: 'hidden',
                }}
            >
                <div ref={bodyRef}>
                    {data.Content}
                </div>
            </div>
        </div>
    );
};

export default Accordion;
